import {QuestionnaireSectionRow, QuestionnaireSectionRowCell} from "benchmarking-domain/questionnaire";
import * as React from "react";
import {useState} from "react";
import {Paper, TableBody, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import {QuestionnaireSectionTableCell} from "./questionnaire-section-table-cell";
import {QuestionnaireSectionTableDiagram} from "./questionnaire-section-table-diagram";
import DataCollection, {DataCollectionData} from "benchmarking-domain/data-collection";
import Card from "@mui/material/Card";
import {DataPointValue} from "benchmarking-domain/data-point";

const QuestionnaireSectionTableCellMemo = React.memo(QuestionnaireSectionTableCell);
const QuestionnaireSectionTableDiagramMemo = React.memo(QuestionnaireSectionTableDiagram);

export interface QuestionnaireSectionTableProps {
  valueIdPrefix?: string;
  rows: QuestionnaireSectionRow[];
  dataCollection?: DataCollectionData;
  dataCollectionChangeHandler: (valueId: string, value: DataPointValue) => Promise<void>;
  globalVariables: DataCollectionData;
}

export function QuestionnaireSectionTable({ valueIdPrefix, rows, dataCollection, dataCollectionChangeHandler, globalVariables }: QuestionnaireSectionTableProps): React.JSX.Element {

  return <TableContainer component={Paper}>
    <Table sx={{ minWidth: 700 }} aria-label="section table">
      <TableBody>
        {rows.map((row, rowIndex) => <TableRow key={rowIndex}>
          {row.cells.map((cell, cellIndex) =>
            <QuestionnaireSectionTableCellMemo key={cell.id ?? (rowIndex + "_" + cellIndex)} valueIdPrefix={valueIdPrefix} cell={cell} dataCollection={cell.type === "input" || cell.type === "calculated" ? dataCollection : undefined} dataCollectionChangeHandler={cell.id ? dataCollectionChangeHandler : undefined} globalVariables={globalVariables} />
          )}
          {row.diagrams?.map((diagram, diagramIndex) =>
            <QuestionnaireSectionTableDiagramMemo key={rowIndex + "_diagram_" + diagramIndex} diagram={diagram} valueIdPrefix={valueIdPrefix} dataCollection={dataCollection} globalVariables={globalVariables} />
          )}
        </TableRow>)}
      </TableBody>
    </Table>
  </TableContainer>
}
